import {SelfieSegmentation} from "@mediapipe/selfie_segmentation";
import {GrmWebRTC} from "@/lib/gooroomee/webrtc/GrmWebRTC";

export default class GrmMediapipeDefault {
    #_init = false;
    
    #options;
    #renderTypeBlur = null;
    // #fpsControl = null;
    // #examples;
    #trackProcessor;
    canvasCtx;
    #backgroundImage;
    
    selfieSegmentation;
    #frameRate
    #oriSrcStream = null;            // original source stream
    srcStream = new MediaStream();  // stream cloned from the original stream
    dstStream = null;               // destination stream
    canvas;
    
    constructor(options={}) {
        this.#options = options;
    }
    
    get getOriSrcStream(){
        return this.#oriSrcStream;
    }

    async init(){
        if(this.#_init ===  false) {
            await (() => {
                if (!this.#options.res || !this.#options.res.sources) {
                    return Promise.resolve();
                }
                return Promise.all(
                    this.#options.res.sources.map(src => {
                        return this.#loadRes(src);
                    })
                );
            })();
            this.#_init = true;
        }
        return this;
    }

    async close(){
        // if(this.selfieSegmentation){
        //     let seg = this.selfieSegmentation;
        //     this.selfieSegmentation = null;
        //     seg.close();
        // }

        if(this.#oriSrcStream && this.srcStream){
            this.srcStream.getVideoTracks().forEach(track => {
                track.stop();
            });
        }
        this.#oriSrcStream = this.srcStream = null;

        this.data.canvasCtx = null;
        try{
            this.data.canvas.remove();
        }catch(e){}
        this.data.canvas = null;

        this.setNoneBackground();
    }
    
    stop(){
        // if(this.dstStream){
            GrmWebRTC.stopMediaStreamVideoTracks(this.dstStream)
            GrmWebRTC.stopMediaStreamVideoTracks(this.srcStream)
            // this.srcStream = null;
            this.dstStream = null;
            this.#oriSrcStream = null;
        // }
    }
    
    // async initControl(){
    //     const controlsElement = document.getElementsByClassName("control-panel")[0];
    //     const canvasElement = document.getElementById("dstVideo");
    //
    //     this.#fpsControl = new window.FPS();
    //     this.#examples = {
    //         images: [],
    //         // {name: 'name', src: 'https://url.com'},
    //         videos: []
    //     };
    //
    //     new window.ControlPanel(controlsElement, {
    //         selfieMode: true,
    //         modelSelection: 1,
    //         effect: "mask"
    //     })
    //         .add([
    //             // new window.StaticText({ title: "MediaPipe Selfie Segmentation" }),
    //             this.#fpsControl,
    //             // new window.Toggle({ title: "Selfie Mode", field: "selfieMode" }),
    //             // new window.SourcePicker({
    //             //     onSourceChanged: () => {
    //             //         selfieSegmentation.reset();
    //             //     },
    //             //     onFrame: async (input, size) => {
    //             //         const aspect = size.height / size.width;
    //             //         let width, height;
    //             //         if (window.innerWidth > window.innerHeight) {
    //             //             height = window.innerHeight;
    //             //             width = height / aspect;
    //             //         }
    //             //         else {
    //             //             width = window.innerWidth;
    //             //             height = width * aspect;
    //             //         }
    //             //         canvasElement.width = width;
    //             //         canvasElement.height = height;
    //             //         // await this.selfieSegmentation.send({ image: input });
    //             //     },
    //             //     examples: this.#examples
    //             // })
    //         ]);
    // }
    
    async createSelfieSegmentation(){
        if(this.selfieSegmentation){
            try{
                this.selfieSegmentation.close();
            }catch(e){
                console.warn('selfieSegmentation.close', e);
            }
            delete this.selfieSegmentation;
        }

        let url = this.#options.selfieSegmentation
        this.selfieSegmentation = new SelfieSegmentation({ locateFile: (file) => {
                // return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`;
                return this.#options.selfieSegmentationUrl + `/${file}`;
            }});
        this.selfieSegmentation.setOptions({
            modelSelection: 0,
        });
        return this.selfieSegmentation;
    }
    
    async getSelfieSegmentation(options={}){
        if(this.selfieSegmentation){
            return this.selfieSegmentation;
        }
        if(options.create !== true){
            return null;
        }
        return this.createSelfieSegmentation();
    }
    
    setStreamEvent(){

    }

    checkTrackProcessor(){
        return !!this.#trackProcessor;
    }
    
    equalsStreamTrack(stream){
        const oriSrcStream = this.#oriSrcStream;
        if(!oriSrcStream || !stream){
            return false;
        }
        if(oriSrcStream.getVideoTracks()[0] === stream.getVideoTracks()[0]){
            return true;
        }
        return false;
    }
    
    async setStream(stream, options={
        stopPrevVideoTrack: true
    }){
        if(!stream || stream.getVideoTracks().length === 0){
            return this.getDstStream();
        }

        if(this.equalsStreamTrack(stream)){
            return this.getDstStream();
        }

        if(options.stopPrevVideoTrack){
            await Promise.all(
                [this.srcStream, this.dstStream].map(stream => {
                    GrmWebRTC.stopMediaStreamVideoTracks(stream)
                })
            );
        }

        this.#oriSrcStream = new MediaStream(stream.getVideoTracks());
        this.srcStream = this.#createCloneStream(stream);

        if(!this.checkTrackProcessor()){
            return Promise.resolve();
        }

        return this.syncStream();
    }
    
    getStream(){
        return this.srcStream;
    }
    
    async syncStream(){
        if(!this.srcStream){
            throw 'source stream is null';
        }

        const videoTrack = this.srcStream.getVideoTracks()[0];
        // const { width, height } = videoTrack.getSettings();

        if(!this.#trackProcessor){
            this.#trackProcessor = {};
        }

        if(this.#trackProcessor.create){
            return this.#trackProcessor.create.finally(() => {
                return this.syncStream();
            });
        }

        if(this.#trackProcessor.readableWork){
            return this.#trackProcessor.readableWork.finally(() => {
                return this.syncStream();
            });
        }

        this.#trackProcessor.create = new Promise(async (resolve, reject) => {
            let {processor} = this.#trackProcessor;
            if(processor && !processor.readable.locked){
                try{
                    await processor.readable.cancel();
                }catch(e){
                    console.error('', e);
                }
            }

            if(videoTrack.readyState === 'ended'){
                reject('video track ended');
                return;
            }

            processor = this.#trackProcessor.processor
                = new MediaStreamTrackProcessor({ track: videoTrack });

            const generator = (() => {
                let generator;
                if(this.dstStream){
                    generator = this.dstStream.getVideoTracks()[0];
                    if(generator && generator.readyState === 'ended'){
                        this.dstStream.removeTrack(generator);
                        generator = null;
                    }
                }
                if(!generator){
                    generator = new MediaStreamTrackGenerator({ kind: 'video' });
                    // generator.addEventListener('ended', e => {
                    //     this.dstStream.removeTrack(e.target);
                    // })
                }
                if(this.dstStream){
                    this.dstStream.addTrack(generator);
                }

                const _ori = generator.stop;
                generator.stop = () => {
                    console.info('# stop generator track', generator)
                    console.info('# stop source tracks', this.srcStream.getVideoTracks())

                    GrmWebRTC.stopMediaStreamVideoTracks(this.srcStream)
                    _ori.apply(generator)
                }
                
                return generator;
            })();

            // let loop = 0;
            // if(!this.#trackProcessor.transform){
            this.#trackProcessor.transform = async (frame, controller) => {
                const canvas = this.getCanvas();
                if (!canvas) {
                    frame.close();
                    return;
                }
                const width = frame.displayWidth;
                const height = frame.displayHeight;
                if(canvas.width !== width || canvas.height !== height){
                    canvas.width = width;
                    canvas.height = height;
                    canvas.dispatchEvent(new Event('resize'));
                }
                frame.width = width;
                frame.height = height;
                const timestamp = frame.timestamp;

                const selfieSegmentation = await this.getSelfieSegmentation();
                if(!selfieSegmentation){
                    return;
                }

                // window.requestAnimationFrame(async () => {
                await selfieSegmentation.send({image: frame});
                frame.close();

                controller.enqueue(new VideoFrame(canvas, {
                    timestamp, alpha: 'discard'
                }));
                // })
            }
            // }

            this.#trackProcessor.readableWork = processor.readable
                .pipeThrough(new TransformStream({
                    transform: this.#trackProcessor.transform
                }))
                .pipeTo(generator.writable)
                .catch(e => {
                    if(e.code === e.INVALID_STATE_ERR){ // generator 에 사용된 소스 track이 stop 된 경우 호출
                        console.log('# stop mediapipe stream')
                    }else{
                        console.warn(e);
                    }
                })
                .finally(() => {
                    this.#trackProcessor.readableWork = null;
                });

            if(!this.dstStream){
                const tracks = this.srcStream
                    .getTracks()
                    .filter(t => t.kind !== 'video');
                tracks.push(generator);

                this.dstStream = new MediaStream(tracks);
            }
            resolve(this.dstStream);
        }).finally(() => {
            this.#trackProcessor.create = null;
        });

        return this.#trackProcessor.create;
    }
    
    async getDstStream(){
        if(this.dstStream){
            return this.dstStream;
        }
        await this.syncStream();
        return this.dstStream;
    }
    
    syncStreamAndCanvas(){
        const canvas = this.getCanvas();

        // canvas.width = video.videoWidth;
        // canvas.height = video.videoHeight;

        const stream = this.getStream();
        if(stream){
            const track = stream.getVideoTracks()[0];
            if(!track) return;
            const settings = track.getSettings();
            if(settings.width){
                canvas.width = settings.width;
                canvas.height = settings.height;
                canvas.dispatchEvent(new Event('resize'));
            }
        }
    }
    
    getCanvas(){
        if(this.canvas){
            return this.canvas;
        }

        const canvas = this.canvas = new OffscreenCanvas(1, 1);
        this.canvasCtx = canvas.getContext('2d');

        this.syncStreamAndCanvas();

        return this.canvas;
    }
    
    getCanvasCtx(){
        if(!this.canvasCtx){
            this.getCanvas();
        }
        return this.canvasCtx;
    }
    
    async setBackgroundByType({type, url}){
        if(type === 'blur'){
            return this.setBlurBackground();
        } else{
            let img;

            if (['blob:', 'data:'].some(imgType => type.startsWith(imgType))) {
                img = type // file url typeect
            } else if (type === 'custom') {
                img = url;
            } else  {
                img = require(`@/assets/images/virtual-background/virtual_background_${type}.jpg`);
            }

            return this.setBackgroundImage({
                img,
            });
        }
    }
    
    async setBackground({onResult}){
        const selfieSegmentation = await this.getSelfieSegmentation({create: true});
        selfieSegmentation.onResults(onResult);

        const dstStream = await this.getDstStream();
        return dstStream;
    }
    
    setBlurBackground(){
        return this.setBackground({onResult: (results) => {
                const canvasCtx = this.getCanvasCtx();
                const canvasElement = canvasCtx.canvas;

                if(!canvasCtx){
                    console.warn('canvasCtx is null');
                    return;
                }

                if(!canvasCtx.save){
                    console.warn('not supported');
                    return;
                }

                // Save the context's blank state
                canvasCtx.save();

                // Draw the raw frame
                canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height);

                // Make all pixels not in the segmentation mask transparent
                canvasCtx.globalCompositeOperation = 'destination-atop';
                canvasCtx.drawImage(results.segmentationMask, 0, 0, canvasElement.width, canvasElement.height);

                // Blur the context for all subsequent draws then set the raw image as the background
                canvasCtx.filter = 'blur(8px)'; // FIXME Does not work on Safari
                canvasCtx.globalCompositeOperation = 'destination-over';
                canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height);

                // Restore the context's blank state
                canvasCtx.restore();
            }})
    }

    setBackgroundImage(options={}){
        let img = options.img;
        if(!img){
            throw 'img is null';
        }
        if(img instanceof HTMLImageElement){
            if(!img.complete){
                return new Promise((resolve, reject) => {
                    img.addEventListener('load', e => {
                        resolve(
                            this.setBackgroundImage.apply(this, arguments)
                        );
                    }, {once: true});
                    img.addEventListener('error', e => {
                        reject(e);
                    }, {once: true});
                })
            }
        }else if(typeof img === 'string'){
            options.img = new Image();
            options.img.src = img;
            return this.setBackgroundImage(options);
        }

        return this._setBackgroundImage(options);
    }
    
    _setBackgroundImage(options={}){
        let img = options.img;
        if(!img){
            throw 'img is null';
        }

        const canvasCtx = this.getCanvasCtx();
        const canvasElement = canvasCtx.canvas;

        const type = options.type; // fit or fill
        const fillColor = options.fillColor || 'black'; // use transparent  as rgba(0, 0, 0, 0)

        let track = this.srcStream.getVideoTracks()[0]
        if(!track){
            console.warn('# track is empty')
        }
        return this.setBackground({onResult: (results) => {
                // Save the context's blank state
                canvasCtx.save();

                canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);

                (() => {
                    let ratio;
                    if(!type || type == 'stretch'){ // default - stretch
                        return canvasCtx.drawImage(img, 0, 0, canvasElement.width, canvasElement.height);
                    }

                    const trackWidth    = typeof track.getConstraints().width === 'object' ? 
                                                track.getSettings().width : track.getConstraints().width;
                    const trackHeight   = typeof track.getConstraints().height === 'object' ?
                                                track.getSettings().height : track.getConstraints().height;
                    const canvasRatio = Math.min(canvasElement.width / trackWidth, canvasElement.height / trackHeight);
                    if(typeof canvasRatio !== 'number') {
                        console.error('trackWidth or trackHeight is not a number')
                        return;
                    }
                    const ratioCanvasWidth = trackWidth * canvasRatio;
                    const ratioCanvasHeight = trackHeight * canvasRatio;

                    if(type=='fit') {
                        canvasCtx.fillStyle = fillColor || 'black';
                        canvasCtx.fillRect(0, 0, canvasElement.width, canvasElement.height);

                        ratio = Math.min(ratioCanvasWidth / img.width, ratioCanvasHeight / img.height);
                        // ratio = Math.min(canvasElement.width / img.width, canvasElement.height / img.height);
                    }else if(type=='fill'){
                        ratio = Math.max(ratioCanvasWidth / img.width, ratioCanvasHeight / img.height);
                        // ratio = Math.max(canvasElement.width / img.width, canvasElement.height / img.height);
                    }

                    const ratioWidth = img.width * ratio;
                    const ratioHeight = img.height * ratio;
                    const stX = (canvasElement.width - ratioWidth) / 2;
                    const stY = (canvasElement.height - ratioHeight) / 2;
                    canvasCtx.drawImage(img, stX, stY, ratioWidth, ratioHeight);
                })();

                canvasCtx.globalCompositeOperation = "destination-out";
                canvasCtx.drawImage(results.segmentationMask, 0, 0, canvasElement.width, canvasElement.height);

                // Only overwrite missing pixels.
                canvasCtx.globalCompositeOperation = "destination-atop";
                canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height);

                // Restore the context's blank state
                canvasCtx.restore();
            }})
    }

    async setNoneBackground(skipCreateSelfieSegmentation){
        this.#renderTypeBlur = false;
        this.#backgroundImage = null;

        if (skipCreateSelfieSegmentation) {
            return await this.getDstStream()
        }

        return this.setBackground({onResult: (results) => {
                const canvasCtx = this.getCanvasCtx();
                const canvasElement = canvasCtx.canvas;

                canvasCtx.save();
                canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height);

                canvasCtx.globalCompositeOperation = 'destination-atop';
                canvasCtx.drawImage(results.segmentationMask, 0, 0, canvasElement.width, canvasElement.height);

                canvasCtx.globalCompositeOperation = 'destination-over';
                canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height);

                // Restore the context's blank state
                canvasCtx.restore();
            }});
    }


    #loadRes(src) {
        let script = document.head.querySelector(`script[src="${src}"]`);
        if(script) {
            return script;
        }

        script = document.createElement('script');
        script.setAttribute('src', src);
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('crossorigin', 'anonymous');
        document.head.appendChild(script);

        return new Promise((resolve, reject) => {
            script.addEventListener('load', resolve);
            script.addEventListener('error', reject);
        });
    }
    
    updateConstraints(newTrack, oriStream){
        oriStream = oriStream || this.#oriSrcStream;
        const frameRate = this.#getProperFrame();
        const cons = oriStream.getVideoTracks()[0].getConstraints();
        
        cons.frameRate = frameRate;
        newTrack.applyConstraints(cons).catch(e => {
            console.warn('', e);
        })
    }
    
    #getProperFrame(){
        if(!this.#frameRate){
            this.#frameRate = (() => {
                let fr = 20;
                if(navigator.userAgent && navigator.userAgent.toLowerCase().includes('mobi')){
                    fr = 15;
                }else if(navigator.hardwareConcurrency <= 8){
                    fr = 15;
                }
                return fr;
            })();
        }
        return this.#frameRate;
    }

    #createCloneStream(stream){
        const track = stream.getVideoTracks()[0];

        if(!this.srcStream){
            this.srcStream = new MediaStream();
        }

        const newTrack = track.clone();
        if(track.getSettings().frameRate <= this.#getProperFrame()){
            GrmWebRTC.stopMediaStreamVideoTracks(this.srcStream)
            GrmWebRTC.stopMediaStreamVideoTracks(this.dstStream)
        }else{
            this.updateConstraints(newTrack);
        }

        const newStream = this.srcStream;
        newStream.addTrack(newTrack)
        // const newStream = new MediaStream(
        //     stream.getAudioTracks().concat([newTrack])
        // );
        
        const eventType = '_grm_mmp_stop';
        const _ori = track.stop;
        newTrack.addEventListener(eventType, e => {
            newStream.removeTrack(newTrack);
            _ori.apply(newTrack);
        });
        
        track.stop = function(){
            stream.removeTrack(track)
            _ori.apply(track);
            newTrack.dispatchEvent(new Event(eventType));
        }
        newTrack.stop = function(){
            track.stop();
        }
        return newStream;
    }
} 